import { render, staticRenderFns } from "./trigger-selector.vue?vue&type=template&id=3a478f41"
import script from "./trigger-selector.vue?vue&type=script&lang=js"
export * from "./trigger-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports